export const getCurrentModal = state => state.modal;
